import { render, staticRenderFns } from "./BodyLastDocuments.vue?vue&type=template&id=13d9b095&scoped=true"
import script from "./BodyLastDocuments.vue?vue&type=script&lang=js"
export * from "./BodyLastDocuments.vue?vue&type=script&lang=js"
import style0 from "./BodyLastDocuments.vue?vue&type=style&index=0&id=13d9b095&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d9b095",
  null
  
)

export default component.exports